module.exports = __webpack_public_path__ + "img/campolivre-galeria-foto03.e7b38b00.jpg";